import React, {useEffect} from "react";
import AuthContainer from "../../containers/AuthContainer";
import {Content} from "../../styles/GlobalStyles";
import {ContentAuth, CardAuth, TitleAuth, CardOptions} from "../auth/components/AuthStyles";
import {ButtonSubmit} from "../../components/footer/styles";
import styled from "styled-components";
import {useHistory, useLocation} from "react-router-dom";
import Color from "../../assets/Colors";

export default function VerifiedAccount() {
   let history = useHistory();
   let location = useLocation();

   useEffect(() => {
      console.log("sdad", location.state);
      if (!location.state) {
         history.goBack();
      }
   }, []);

   return (
      <>
         <AuthContainer>
            <Content>
               <ContentAuth>
                  <CardAuth>
                     {location.state &&
                        (!location.state.verified ? (
                           <>
                              <div className="head">
                                 <TitleAuth>¡Error! No se pudo validar tu cuenta.</TitleAuth>
                              </div>
                              <CardOptions>
                                 {/* <InitButton
                                    onClick={() => {
                                       history.replace("/iniciar_sesion");
                                    }}
                                 >
                                    INICIAR SESIÓN
                                 </InitButton> */}
                              </CardOptions>
                           </>
                        ) : (
                           <>
                              <div className="head">
                                 <TitleAuth>¡Felicidades! Tú cuenta ha sido verficada</TitleAuth>
                              </div>
                              <CardOptions>
                                 <InitButton
                                    onClick={() => {
                                       history.replace("/iniciar_sesion");
                                    }}
                                 >
                                    INICIAR SESIÓN
                                 </InitButton>
                              </CardOptions>
                           </>
                        ))}
                  </CardAuth>
               </ContentAuth>
            </Content>
         </AuthContainer>
      </>
   );
}

const InitButton = styled(ButtonSubmit)`
   padding: 0.5em 1em;
   color: ${Color.primary};
`;
